export const common = {
  siteName: "AllChinaBuy Spreadsheet",
  siteTagline: "Trusted Links & Buying Guides",
  buyItNow: "Buy It Now",
  allchinabuySheet: "AllChinaBuy Sheet",
  browseSpreadsheet: "Browse Spreadsheet",
  startBuying: "Start Buying",
  viewSellers: "View Trusted Sellers",
  exploreNow: "Start Exploring The Latest Spreadsheet →",
  backToHome: "Back to Homepage",
  readMore: "Read More",
  subscribe: "Subscribe",
  emailPlaceholder: "Your email address",
  emailLabel: "Email",
  copyright: "© 2026 AllChinaBuy Spreadsheet. All rights reserved.",
  categories: "Categories",
  quickLinks: "Quick Links",
  siteLinks: "Site Links",
  newsletterTitle: "Get The / Best Links",
  newsletterDesc: "Subscribe to receive weekly spreadsheet updates, new product finds, and exclusive buying tips.",
};